(function () {
  'use strict';

  /* ── Announcement bar height CSS variable ──────────────────────────────────
   * Sets --mn-announcement-height on :root so navigation CSS can offset:
   *   - .menu-drawer__navigation-container padding-top (drawer aligns with nav)
   *   - .mn-mobile-search top (search overlays sticky-header, not announcement)
   * Updated on resize and when the announcement bar is dismissed.
   * ─────────────────────────────────────────────────────────────────────── */
  function setAnnouncementHeight() {
    var bar = document.getElementById('Announcement-header');
    var h = (bar && bar.offsetHeight > 0) ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--mn-announcement-height', h + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setAnnouncementHeight);
  } else {
    setAnnouncementHeight();
  }
  window.addEventListener('resize', setAnnouncementHeight);

  /* Watch for announcement bar dismissal (attribute change or removal from DOM) */
  var announcementBar = document.getElementById('Announcement-header');
  if (announcementBar) {
    new MutationObserver(setAnnouncementHeight).observe(announcementBar, {
      attributes: true, childList: false, subtree: false
    });
    if (announcementBar.parentNode) {
      new MutationObserver(setAnnouncementHeight).observe(announcementBar.parentNode, {
        childList: true
      });
    }
  }

  /* Watch body for shopify-section-header-hidden class (Shopify hides header on scroll) */
  new MutationObserver(setAnnouncementHeight).observe(document.body, {
    attributes: true, attributeFilter: ['class']
  });

  /* ── Drawer open/close body class ─────────────────────────────────────── */
  var drawer = document.querySelector('.mobile-menu-drawer');
  if (drawer) {
    function ensureTabpanelVisible() {
      var drawerTabs = document.querySelector('#menu-drawer automatic-tabs');
      if (!drawerTabs) return;
      var panels = drawerTabs.querySelectorAll('.tabpanel');
      if (!panels.length) return;
      var anyVisible = Array.from(panels).some(function(p) { return !p.hasAttribute('hidden'); });
      if (!anyVisible) {
        // All panels are hidden — show panel 0 and hide the rest directly,
        // bypassing AutomaticTabs in case aria-controls was never set.
        panels.forEach(function(p, i) {
          if (i === 0) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', 'hidden');
          }
        });
        var firstTab = drawerTabs.querySelector('.tablist button');
        if (firstTab) {
          firstTab.setAttribute('aria-selected', 'true');
          firstTab.setAttribute('tabindex', '0');
        }
      }
    }

    var drawerObserver = new MutationObserver(function () {
      if (drawer.hasAttribute('open')) {
        document.body.classList.add('mn-drawer-open');
        ensureTabpanelVisible();
        setTimeout(ensureTabpanelVisible, 50);
        setTimeout(ensureTabpanelVisible, 200);
        setTimeout(ensureTabpanelVisible, 600);
      } else {
        document.body.classList.remove('mn-drawer-open');
      }
    });
    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  /* ── Forward non-Algolia search forms to the Algolia-initialised form ── */
  /* CSS variable --aa-detached-media-query:all forces aa-DetachedSearchButton to be
     injected on every viewport. Algolia initialises on whichever form has
     algolia-search-form first in DOM (drawer on mobile, header on desktop via class swap).
     We search both containers so forwarding works regardless of which form got it. */
  function findDetachedBtn() {
    return document.querySelector('.mn-drawer-search .aa-DetachedSearchButton')
        || document.querySelector('.mn-search-wrap .aa-DetachedSearchButton');
  }
  document.addEventListener('click', function (e) {
    var inStacked       = e.target.closest('.mn-mobile-search-bar .mn-search');
    var inDesktop       = e.target.closest('.mn-search-wrap .mn-search');
    var inHamburgerIcon = e.target.closest('.mn-hamburger-search');
    var inMobileBtn     = e.target.closest('.mn-search-mobile');
    if (inStacked || inHamburgerIcon || inMobileBtn) {
      e.preventDefault();
      var btn = findDetachedBtn();
      if (btn) btn.click();
    } else if (inDesktop) {
      var btn = findDetachedBtn();
      if (btn) { e.preventDefault(); btn.click(); }
    }
  }, false);

  /* ── Rotating search placeholder ──────────────────────────────────────── */
  var config = window.MNNav || {};
  var placeholders = config.placeholders || [];
  if (placeholders.length >= 2) {
    var inputs = document.querySelectorAll('.mn-search__rotating');
    if (inputs.length) {
      var idx = 0;
      setInterval(function () {
        idx = (idx + 1) % placeholders.length;
        inputs.forEach(function (el) {
          if (el !== document.activeElement) {
            el.setAttribute('placeholder', placeholders[idx]);
          }
        });
      }, 3000);
    }
  }
})();

/* ── Country selector: close on outside click ── */
document.addEventListener('click', function(e) {
  var selector = document.getElementById('mn-country-selector');
  if (selector && !selector.contains(e.target)) {
    selector.removeAttribute('open');
  }
});
